var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejectedState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.21,
    height: 12,
    viewBox: "0 0 13.21 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22037",
    "data-name": "Group 22037",
    transform: "translate(-104 -344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2_-_Outline",
    "data-name": "Polygon 2 - Outline",
    d: "M8.084,1.969a2.371,2.371,0,0,1,2.067,1.187l4.209,7.215a2.393,2.393,0,0,1-2.067,3.6H3.875a2.393,2.393,0,0,1-2.067-3.6L6.017,3.156A2.371,2.371,0,0,1,8.084,1.969Z",
    transform: "translate(102.521 342.031)",
    fill: "#ef5a46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22362",
    "data-name": "Group 22362",
    transform: "translate(-29.159 0.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38872",
    "data-name": "Path 38872",
    d: "M18,13.5v3.273",
    transform: "translate(121.859 333.077)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38873",
    "data-name": "Path 38873",
    d: "M18,25.5h0",
    transform: "translate(121.859 327.077)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedState);
export default __webpack_public_path__ + "static/media/rejected_state.a9080142600cc8a78ca303a248445124.svg";
export { ForwardRef as ReactComponent };